import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { LeaveRequestStatus } from '../types';

export type StatusFilterValue = 'ALL' | LeaveRequestStatus;

interface StatusFilterSelectProps {
  value: StatusFilterValue;
  onChange: (value: StatusFilterValue) => void;
  label?: string;
  size?: 'small' | 'medium';
}

const STATUS_OPTIONS: Array<{ label: string; value: StatusFilterValue }> = [
  { label: 'All statuses', value: 'ALL' },
  { label: 'Pending', value: 'PENDING' },
  { label: 'Change requested', value: 'CHANGE_PENDING' },
  { label: 'Approved', value: 'APPROVED' },
  { label: 'Denied', value: 'DENIED' },
  { label: 'Cancelled', value: 'CANCELLED' },
];

export const StatusFilterSelect: React.FC<StatusFilterSelectProps> = ({
  value,
  onChange,
  label = 'Status',
  size = 'small',
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value as StatusFilterValue);
  };

  return (
    <FormControl size={size} sx={{ minWidth: 160 }}>
      <InputLabel>{label}</InputLabel>
      <Select value={value} label={label} onChange={handleChange}>
        {STATUS_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StatusFilterSelect;
